import React, {PureComponent} from 'react';
import CheckSquare from 'react-feather/dist/icons/check-square';
import FileText from 'react-feather/dist/icons/file-text.js';
import Search from 'react-feather/dist/icons/search.js';
import UserCheck from 'react-feather/dist/icons/user-check.js';

import {generate} from '../../routes.js';

import LinkAs from "../LinkAs/LinkAs.jsx";

import './HowToGetMissions.scss';

export default class HowToGetMissions extends PureComponent {
  render() {
    return <section id="how-to-get-missions" className="container text-center py-5">
      <h2 className="mb-4">Comment obtenir un mandat avec Twineeds ?</h2>
      <div className="row justify-content-center mb-4">
        <div className="col-12 col-sm-6 col-lg-3 d-flex flex-column p-2 p-md-3">
          <FileText/>
          <h3>Inscrivez-vous</h3>
          <p>
            Avec un CV ou un profil Linkedin. Renseignez vos contraintes principales et prenez rendez-vous pour nous
            rencontrer.
          </p>
        </div>
        <div className="col-12 col-sm-6 col-lg-3 d-flex flex-column p-2 p-md-3">
          <UserCheck/>
          <h3>Rencontrez-nous</h3>
          <p>
            Faisons connaissance : permettez nous de comprendre votre profil et vos expériences, vos attentes et vos
            contraintes.
          </p>
        </div>
        <div className="col-12 col-sm-6 col-lg-3 d-flex flex-column p-2 p-md-3">
          <CheckSquare/>
          <h3>Finalisez votre inscription</h3>
          <p>
            Nous vous demandrons des informations qui nous permettront à la fois de lier votre expérience à des mandats
            à pourvoir et soutenir vos candidatures.
          </p>
        </div>
        <div className="col-12 col-sm-6 col-lg-3 d-flex flex-column p-2 p-md-3">
          <Search/>
          <h3>On vous recontacte !</h3>
          <p>
            Lorsqu'un mandat est à pourvoir, Twineeds vous recontacte par téléphone, SMS ou email afin d'aborder votre
            potentielle candidature.
          </p>
        </div>
      </div>
      <LinkAs
        className="btn btn-primary"
        notConnected={generate({name: 'register-freelance'})}
        freelance={generate({name: 'freelance-dashboard'})}
      >
        S'inscrire
      </LinkAs>
    </section>;
  }
}
